import { updateSellerAction } from 'redux/actions/sellersActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(updateSellerAction);
